





import { Component, Prop } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'
import myMenuService from '~/service/my-menu-service'

@Component
export default class extends HsComponent {
  // #region variables
  @Prop() menu: any
  // #endregion
  // #region hooks
  // #endregion
  // #region methods
  async clicked() {
    if (!this.menu?.menuId) return

    if (this.menu.fav) {
      this.$ustra.hs.store.menuData.removeMyMenu(this.menu.menuId)
      await myMenuService.removeMyMenu(this.menu.menuId)
    } else {
      this.$ustra.hs.store.menuData.addMyMenu(this.menu)
      await myMenuService.addMyMenu(this.menu)
    }
  }
  // #endregion
  // #region watches
  // #endregion
}
